export default __webpack_public_path__ + "static/media/sentient-product.ccb55659.svg";